/** 네비 숨김 높이를 반영하되, 이동 후 고정 제목·언어 탭에 가려지지 않을 여백을 확보한다. */
export function adjustNavbarScrollOffset(visibleOffset: number, targetTop: number): number {
  const style = getComputedStyle(document.documentElement);
  const height = Number.parseFloat(style.getPropertyValue("--mobile-navbar-height"));
  const offset = Number.parseFloat(style.getPropertyValue("--mobile-navbar-offset"));
  if (!Number.isFinite(height) || !Number.isFinite(offset)) return visibleOffset;

  // 위로 이동하면 네비가 다시 나타나므로 표시 상태의 여백을 예약한다.
  const movingUp = targetTop - visibleOffset < window.scrollY;
  const destinationNavbarHeight = movingUp ? height : offset;
  const adjusted = visibleOffset + destinationNavbarHeight - height;

  const title = Array.from(document.querySelectorAll<HTMLElement>("#sticky-title"))
    .find((element) => element.parentElement?.getClientRects().length);
  const titleHeight = title && !(title.classList.contains("max-md:hidden") && window.innerWidth < 768)
    ? (title.offsetHeight || (window.innerWidth >= 640 ? 52 : 48))
    : 0;
  const languageToggle = Array.from(document.querySelectorAll<HTMLElement>(
    '[class*="language-toggle-navbar-fallback"]',
  )).find((element) => element.getClientRects().length > 0);
  const languageStyle = languageToggle ? getComputedStyle(languageToggle) : null;
  const languageBottom = languageToggle && languageStyle?.position === "sticky"
    ? Number.parseFloat(languageStyle.top) - offset + languageToggle.offsetHeight
    : 0;

  return Math.max(0, adjusted, destinationNavbarHeight + Math.max(titleHeight, languageBottom) + 16);
}
